module.exports = __webpack_public_path__ + "static/HKGrotesk-BoldItalic-680e74b511f49029feb14026f9a9f135.ttf";